// generated by the plop

import { Injectable } from '@angular/core';
import { Action, NgxsOnInit, Selector, State, StateContext } from '@ngxs/store';
import { BackupService } from '../../backup.service';
import { ChangeBackupStatus, CreateBackup, GetBackupStatus } from './backups.actions';
import { BACKUPS_STATE_DEFAULT, BackupsStateModel } from './backups.model';

@State({ name: 'Backups', defaults: BACKUPS_STATE_DEFAULT })
@Injectable()
export class BackupsState implements NgxsOnInit {

  constructor(private backupService: BackupService) {
  }

  @Selector()
  static status(state: BackupsStateModel): BackupsStateModel['status'] {
    return state.status;
  }

  ngxsOnInit(ctx: StateContext<any>) {
    ctx.dispatch(new GetBackupStatus());
  }

  @Action(ChangeBackupStatus)
  changeBackupStatus(ctx: StateContext<BackupsStateModel>, { status }: ChangeBackupStatus): void {
    ctx.patchState({
      status
    });
  }

  @Action(GetBackupStatus)
  getBackupStatus(ctx: StateContext<BackupsStateModel>): void {
    this.backupService.getBackupStatus()
      .subscribe({
        next: status => ctx.patchState({ status })
      });
  }

  @Action(CreateBackup)
  createBackup(ctx: StateContext<BackupsStateModel>): void {
    this.backupService.createBackup().subscribe();
  }
}


